import request from '@/utils/request';
//素材分页
export function getMaterialList(values) {
  return request('/material/queryPage', {
    method: 'POST',
    data: values,
  });
}
//删除单个素材
export function deleteMaterial(values) {
  return request('/material/delete', {
    method: 'POST',
    data: values,
  });
}
